import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchCharitableOrgs } from "../../services/axios/apiManager";
import OrganizationList from "./organizationList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";

const CharitableOrganizatons = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [charitableOrgs, setCharitableOrgs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter(
      (f) => f.module === "Charitable_Organizations"
    );
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await fetchCharitableOrgs();
    if (res?.data?.success && res?.data?.data) {
      setCharitableOrgs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div className="text-light container" style={{ paddingTop: "30px" }}>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                    data-testid="organizatioeading"
                  >
                    Charitable Organizations
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <OrganizationList
          charitableOrgs={charitableOrgs}
          setCharitableOrgs={setCharitableOrgs}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};
export default CharitableOrganizatons;
